import { decode, encode } from "js-base64";
import { useHistory } from "react-router-dom";

import useSearchParams from "./useSearchParams";

export function useQueryState(state) {
	const searchParams = useSearchParams();
	const history = useHistory();

	const encodeData = (data) => {
		return encodeURIComponent(encode(JSON.stringify(data)));
	};

	const decodeData = (data) => {
		return JSON.parse(decode(decodeURIComponent(data)));
	};

	const getState = () => {
		return {
			...state,
			...(searchParams.filters ? decodeData(searchParams.filters) : {}),
		};
	};

	const setState = (values) => {
		const newState = {
			...getState(),
			...values,
		};

		const params = new URLSearchParams(location.search);
		params.set("filters", encodeData(newState));
		history.replace(`${location.pathname}?${params.toString()}`);
	};

	return [getState(), setState];
}
